import { useAppointment } from "@/features/appointments/hooks/appointmentQueries";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { useClient } from "@/features/clients/hooks/clientQueries";
import { useServices } from "@/features/services/hooks/serviceQueries";

export function AppointmentNotificationSubtitle({
  appointmentId,
  fallback,
}: {
  appointmentId: string;
  fallback: string;
}) {
  const { businessId } = useCurrentBusiness();
  const { data: appointment } = useAppointment(appointmentId);
  const scopedAppointment = appointment?.businessId === businessId ? appointment : undefined;
  const { data: client } = useClient(scopedAppointment?.clientId ?? "");
  const { data: services } = useServices();
  const customer = client?.businessId === businessId
    ? [client?.firstName, client?.lastName].filter(Boolean).join(" ")
    : "";
  const serviceNames = scopedAppointment?.services
    .map((item) => services?.find((service) => service.id === item.serviceId)?.name)
    .filter(Boolean)
    .join(", ");
  // Notifications have no structured customer/service fields; retain their message if related records are unavailable.
  const subtitle = customer && serviceNames ? `${customer} · ${serviceNames}` : fallback;

  return (
    <p className="truncate text-xs leading-normal text-muted-foreground" title={subtitle}>
      {subtitle}
    </p>
  );
}
